
import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import textFilter from "../../../../../helper/textFilter"
import {MdKeyboardArrowRight} from "react-icons/md"
import { handleActiveSelect } from "../../../../../features/layout/layoutSlice"
import locationData from "../../../../../utils/locationData/locationOptions"
import { updateRouteItem } from "../../../../../features/updateLoad/updateLoadSlice"
import { useEffect } from "react"
import yuklemeData from "../../../../../utils/yukOptions/yuklemeData"

const Container = styled.div`
    width: 500px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-color: ${({isError}) => isError && "var(--color-red)"};

        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        height: 300px;
        overflow: auto;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;


            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }

`

const YuklemeCityTownInput = ({data, isRequired, labelText="İlçe/İl Seçiniz", name}) => {

    const [text, setText] = useState(data.locationData.location)

    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)
    const [isError, setIsError] = useState(false)
    const {showErrors, showRequiredPlaces} = useSelector(state => state.updateLoad)

    const [options, setOptions] = useState(locationData)
    

    //! her zaman state deki değeri al
    useEffect(() => {
        setText(data.locationData.location)
    },[data.locationData.location])

    const handleChange = (e) => {
        const searchText = e.target.value
        dispatch(handleActiveSelect(name))

        if(data.locationData.location){
            // dispatch(updateRouteItem({...yuklemeData, id: data.id}))
        }

        if(!searchText){
            setOptions(locationData)
            // dispatch(handleActiveSelect(null))
        }

        if(searchText){
            const result = textFilter(locationData, searchText, "location")
            setOptions(result)
        }

        setText(searchText)
    }

    const handleOptionClick = (item) => {

        dispatch(handleActiveSelect(null))

        const updatedItem = {
            id: data.id,
            locationData: {
            il: item["city"],
            ilce: item["town"],
            lat: item["lat"],
            lng: item["lng"],
            location: item["location"],
            bolge: item["region"],
            ilId: item["cityId"],
            ilceId: item["townId"],
            isGoogleAddressSelected: data.locationData.isGoogleAddressSelected,
            googleLat: data.locationData.googleLat,
            googleLng: data.locationData.googleLng,
            googleLocation: data.locationData.googleLocation,
            googleSearchText: data.locationData.googleSearchText,
            isfirstChanged: data.locationData.isfirstChanged,
            }
        }
        dispatch(updateRouteItem(updatedItem))
    }

    useEffect(() => {
        //! bu submit esnasında boş girerse gösterilecek 
        if(isRequired && !data.locationData.il && !data.locationData.ilce && showErrors){
            return setIsError(true)
        }
        //! bu kullanıcı zorunlu alanları görüntülemek isterse
        if(isRequired && showRequiredPlaces){
           return setIsError(true)
        }
        else{
            setIsError(false)
        }
    },[isRequired, data.locationData.il, data.locationData.ilce, showRequiredPlaces, showErrors])

    //! active olan item ın arka planını hafif sarı yaparsın

  return (
    <Container onClick={(e) => e.stopPropagation()} value={text} radius={"5px"} isActive={activeSelect === name} isError={isError}>
        <input type="text" id={"text"} onChange={handleChange} value={text} name={name} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}{isRequired && "*"}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        options.map((item) => (
                            <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
                                {item.location}
                            </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default YuklemeCityTownInput